export const LayoutVariants = Object.freeze({
    Default: 'default',
    Column: 'column'
});

export type LayoutVariant = (typeof LayoutVariants)[keyof typeof LayoutVariants];
